<template>
    <DrawablePhoto
        :image="null"
        :drawing="this.item.response && this.item.response.drawing ? this.item.response.drawing : null"
        :width="480"
        :height="240"
        :show-thumbnail="false"
        :colors="[{ color: '#000000', marker: '#ffffff' }]"
        :title="$t('Sign here')"
        :remove-button-title="$t('Remove signature')"
        :can-be-deleted="false"
        @change="updateDrawing"
    />
</template>

<script>
    import DrawablePhoto from '@/components/DrawablePhoto/DrawablePhoto.vue';

    export default {

        components: { DrawablePhoto },

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        methods: {
            updateDrawing(drawing) {
                if (drawing === null) {
                    this.$delete(this.item, 'response');
                    this.$delete(this.item, 'responded');
                } else {
                    this.$set(this.item, 'response', { drawing });
                    this.$set(this.item, 'responded', true);
                }
            },
        },
    };

</script>
